import { useState } from "react";
import useWexClient from "./Clients/wexClient,";

export const useAuthClient = () => {
  const { login } = useWexClient();
  const [] = useState();
  
  const loginClient = async (user, password) => {
    try {
      const response = await login(user, password);
      return response;
    } catch (err) {
      throw(err);
    }
  }

  return {
    loginClient
  }
};
